import { useState } from "react";
import { AdminModules } from "../features";
import { gql, useMutation } from "@apollo/client";
import { useApolloQuery } from "../../../../hooks";
import { useAuthSession } from "../../../../components/AuthSessionProvider";
import { useNotify } from "../../../../components/@common/NotificationsProvider";
import { useNavigate } from "react-router-dom";
import {
  ConfirmationDeleteModal,
  useLanguageTranslator,
} from "../../../../components";
import dayjs from "dayjs";

const GET_PRACTICECATEGORIES_WITH_PAGINATION = gql`
  query GetPracticeCategoriesWithPagination($page: Int!) {
    practiceCategoriesWithPagination(page: $page) {
      collection {
        createdAt
        id
        name
        updatedAt
      }
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
    }
  }
`;

const DELETE_PRACTICECATEGORY = gql`
  mutation PracticeCategoryDelete($id: ID!) {
    practiceCategoryDelete(input: { id: $id }) {
      clientMutationId
      practiceCategory {
        createdAt
        id
        name
        updatedAt
      }
    }
  }
`;

function PracticeCategories() {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isOpenDelete, setIsOpenDelete] = useState({ status: false, data: {} });

  const { user } = useAuthSession() as any;
  const notify = useNotify();
  const navigate = useNavigate();
  const { translator } = useLanguageTranslator();

  const {
    data: practiceCategoriesList,
    loading,
    refetch,
  } = useApolloQuery({
    queryDocument: GET_PRACTICECATEGORIES_WITH_PAGINATION,
    isPrivateCall: true,
    variables: {
      page: page,
    },
  });

  const [deletePracticeCategory, { loading: deleteLoading, error }] =
    useMutation(DELETE_PRACTICECATEGORY, {
      context: {
        headers: {
          "access-token": user?.accessToken,
          client: user?.client,
          uid: user?.email,
        },
      },
    });

  const modifiedGetPracticeCategories =
    practiceCategoriesList?.practiceCategoriesWithPagination?.collection?.map(
      (item: any) => {
        return {
          sr: item?.id,
          id: item?.id,
          name: item?.name,
          createdAt: dayjs(item?.createdAt?.split("T")?.[0] || "").format(
            "DD.MM.YYYY"
          ),
          updatedAt: dayjs(item?.updatedAt?.split("T")?.[0] || "").format(
            "DD.MM.YYYY"
          ),
        };
      }
    );

  async function onClickHandler(type: string, clickedId: any) {
    if (type === "edit") {
      navigate(`/admin/practice-categories/update?id=${clickedId}`);
      return;
    }
    if (type === "delete") {
      setIsOpenDelete({ status: true, data: { id: clickedId } });
    }
  }

  async function onClickDeleteHandler(item: any) {
    const response = await deletePracticeCategory({
      variables: { id: Number(item?.id) },
    });
    if (response?.data) {
      notify.success(`Practice Category Delete successfuly!`);
      setIsOpenDelete({ status: false, data: {} });
      setTimeout(async () => {
        await refetch();
      }, 1000);
    }
  }

  function handleDeleteClose() {
    setIsOpenDelete({ status: false, data: {} });
  }

  return (
    <>
      <ConfirmationDeleteModal
        isOpen={isOpenDelete?.status}
        item={isOpenDelete?.data}
        onClickHandler={onClickDeleteHandler}
        handleClose={handleDeleteClose}
      />
      <AdminModules
        title={translator("Practice Categories")}
        path="/admin/practice-categories/add-new"
        data={modifiedGetPracticeCategories || []}
        moduleKey="PracticeCategories-module"
        page={page}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        setPage={setPage}
        onClickHandler={onClickHandler}
        metadata={
          practiceCategoriesList?.practiceCategoriesWithPagination?.metadata || {}
        }
      />
    </>
  );
}

export { PracticeCategories };
